import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import AFN_Logo from '../res/images/afn-new-logo.svg';
import appleStoreIcon from '../res/images/app-store-icon.svg'
import playStoreIcon from '../res/images/play-store-icon.svg'


const Home = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const region = sessionStorage.getItem('region_name') ? sessionStorage.getItem('region_name') : ''
  }, [])

  const handleSelect = (value) => {
    sessionStorage.setItem('region_name', value)
    navigate(`/afn${value.toLowerCase()}`)
  }
  // const handleSelectNews = (value) => {
  //   sessionStorage.setItem('region_name', value)
  //   navigate(`radioList`)
  // }

  return (
    <>
      <section className="splash-bg">
        <div className="container">
          {/* <div className="navbar-nav radio-list radio-list-nav">
          <div className="page-heading">
            
            <select class="form-select selectRegion" value={selectRegion} onChange={(e) =>handleSelect(e) } aria-label="Default select example">
              <option value=''>Select  Region </option>
              {RadioListData.station.map((element) => (
                <option value={element.region}>{element.region}</option>
              ))}
            </select>
          </div>
          <Link className="nav-item nav-link" to="/radioList" >RadioList</Link>
        </div> */}
          <div className='row justify-content-center'>
            <div className='col-lg-12'>
              <div className="afn-logo button-logo-box">
                <img src={AFN_Logo} alt="logo" className="img-fluid" />
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='homeTextBox'>
                <p>
                  AFN Go is the American Forces Network’s official audio streaming service available to the authorized audience serving outside of the United States, its territories, and possessions.
                </p>
                <p>
                  AFN Go connects listeners to their local AFN The Eagle radio station and provides links to currency exchange rates, weather, and traffic.
                </p>
                <p>
                  Additionally, app users can elect to receive community-specific emergency push notifications about important issues and events impacting their safety, wellbeing, and situational awareness.
                </p>
                <p>
                  The AFN Go mobile app is available for free on the Apple App Store and Google Play and does not require a user account or registration.
                </p>
                <p>
                This app is for listening to AFN Radio. Information on the AFN|now streaming tv app can be found at: <a href="https://afn-now.myafn.mil/" target="_blank" class="tvScheduleLink"> https://afn-now.myafn.mil/ </a>
                </p>
              </div>
            </div>
            <div className='clearfix'></div>
            <div className='col-lg-8'>
              <div className="button-container">
                <div>
                  <img src={AFN_Logo} alt="logo" className="img-fluid" />
                  <button className='station-btn' onClick={() => handleSelect('Europe')}>
                    Europe Stations
                  </button>
                </div>
                <div>
                  <img src={AFN_Logo} alt="logo" className="img-fluid" />
                  <button className='station-btn' onClick={() => handleSelect('Pacific')}>
                    Asia-Pacific Stations
                  </button>
                </div>
              </div>
            </div>
            <div className='clearfix'></div>
            <div className='col-lg-8'>
              <div className='storeIconBox'>
                <div className='appleStoreIcon'>
                  <a href='https://apps.apple.com/us/app/afn-go/id1614081529' target="_blank">
                    <img src={appleStoreIcon} alt="logo" className="img-fluid" />
                  </a>
                </div>
                <div className='playStoreIcon'>
                  <a href='https://play.google.com/store/apps/details?id=com.afn360' target="_blank">
                    <img src={playStoreIcon} alt="logo" className="img-fluid" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="afn-logo button-logo-box">
            <img src={AFN_Logo} alt="logo" className="img-fluid" />
          </div> */}
          {/* <div className="button-container">
            <button className='station-btn' onClick={()=>handleSelectNews('News & Sports')}>
            News & Sports
            </button>
          </div> */}
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
}

export default Home;